import NoData from "assets/svgs/no_data/NoData";
import moment from "moment";
import React from "react";

function TaskComponent(task) {
  return (
    <div
      className="gap-2"
      style={{ display: "grid", gridTemplateColumns: "1fr 1fr", zIndex: "-1" }}
    >
      {task?.task?.length ? (
        task?.task?.map((item) => {
          return (
            <div className="d-flex bg-white rounded shadow p-2">
              <div className="d-flex flex-row gap-2">
                <img
                  src={item?.urlOrText}
                  style={{ height: "50px", width: "50px" }}
                ></img>
                <div>
                  <div className="fs-2">{item?.h1}</div>
                  <div className="fs-1">{item?.h2}</div>
                  {item?.h3?.map((item) => {
                    return <div>{item}</div>;
                  })}
                  <div className="border-bottom"></div>
                  <div>{item?.completdBy}</div>
                  <div className="d-flex gap-2">
                    <span className="fw-bold">StartDate : </span>
                    <span className="">
                      {moment(item?.startDate)
                        .utcOffset("+05:30")
                        .format("YYYY-MM-DD HH:mm")}
                    </span>
                  </div>
                  <div className="d-flex gap-2">
                    <span className="fw-bold">DueDate : </span>
                    <span className="">
                      {moment(item?.dueDate)
                        .utcOffset("+05:30")
                        .format("YYYY-MM-DD HH:mm")}
                    </span>
                  </div>
                  <div className="d-flex gap-2">
                    <span className="fw-bold">completedDate : </span>
                    <span className="">
                      {moment(item?.completedDate)
                        .utcOffset("+05:30")
                        .format("YYYY-MM-DD HH:mm")}
                    </span>
                  </div>
                  <div className="d-flex gap-2">
                    <span className="fw-bold">Event Name:</span>
                    <span>{item?.eventName}</span>
                  </div>
                  <div className="d-flex gap-2">
                    <span className="fw-bold">Priority : </span>
                    <span>{item?.priority}</span>
                  </div>
                  <div className="d-flex gap-1">
                    <span className="fw-bold">Task Detail id:</span>
                    <span className="">{item?.userTaskDetailId}</span>
                  </div>
                  <div className="d-flex gap-1">
                    <span className="fw-bold">Completed By :</span>
                    <span className="">{item?.completedBy}</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div style={{ marginLeft: "60%" }}>
          No data available <NoData />
        </div>
      )}
    </div>
  );
}

export default TaskComponent;
